import React from 'react'
import Button from '@material-ui/core/Button';

export default function BackNextButtons(props)
{

  const handleNextButton = (e) => {
    props.nextStep();
  };

  const handleBackButton = (e) => {
    if (props.id === 'GeneralInfo') {
      props.clearState();
    }
    props.prevStep();
  };

  const trackButtonClick = (buttonName, additionalData = {}) => {
    if (typeof window.gtag !== 'undefined') {
      // Force immediate send with beacon transport
      window.gtag('config', 'G-GWQNXWB6G7', {
        'transport_type': 'beacon'
      });

      window.gtag('event', buttonName, {
        'button_name': buttonName,
        'button_location': 'form_buttons',
        'timestamp': new Date().toISOString(),
        ...additionalData
      });

      console.log('Tracking event:', buttonName, {
        'button_name': buttonName,
        'button_location': 'form_buttons',
        'timestamp': new Date().toISOString(),
        ...additionalData
      });
    } else {
      console.warn('gtag is not defined');
    }
  };

  return (
    <div id="BackNextButtons" style={{ display: "flex", marginTop: '4rem' }}>
      <Button 
        variant="outlined" 
        onClick={handleBackButton} 
        id="backButton" 
        className={props.id}
      >
        Back
      </Button>

      {props.id === "EstimatedRates" ? (
        ''
      ) : props.id === "GeneralInfo" ? (
        <Button 
          variant="contained" 
          type="submit" 
          id="nextButton" 
          className={props.id}
        >
          Find my price
        </Button>
      ) : props.id === "Services" ? (

        // If connection option is empty when broadband is selected, do not display the button
        props.values.broadbandArray.includes('broadband') && props.values.connectionOption === '' ? ( 
          <div>&nbsp;</div>
        ) : (
          <Button
            variant="contained"
            onClick={handleNextButton}
            id="nextButton"
            className={props.id}
          >
            Next
          </Button>
        )

      ) : props.id === "CustomerDetails" ? (
        <Button
          variant="contained"
          type="submit"
          id="nextButton"
          onClick={() => {
            trackButtonClick('enter_your_details_completed', {
              'page': props.id,
              'button_type': 'submission'
            });
            props.toTop();
          }}
          className={props.id}
        >
          Finish
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleNextButton}
          id="nextButton"
          className={props.id}
        >
          Next
        </Button>
      )}
    </div>
  );
}
